module.exports = __webpack_public_path__ + "static/media/Life.1e16e475.svg";